module.exports = __webpack_public_path__ + "static/media/settings.28f7cd8c.png";